/**
 * Alibaba Lens — reverse-image / product search helper for Alibaba.com
 *
 * Declares three separate web-accessible-resource entries, each a content-script
 * stylesheet (content.css, floating-find-similar.css, selection-toolbar.css), all matched
 * to every origin with no dynamic URL. There are no bundled images exposed, so detection
 * relies on fetching the vendor-named CSS, each reachable from any page at a fixed URL.
 *
 * Manifest verified against version 1.3.4.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jjpbbahenfdgofabbgcnnfejgcigadpd';

export const alibabaLens: ExtensionDefinition = {
  id: ID,
  name: 'Alibaba Lens: Official Alibaba.com Image Search Tool for Wholesale Supply',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Three static content-script stylesheets exposed to every origin with no dynamic URL. ' +
    'No image WAR, so detection is a fetch of the CSS and conclusive.',
  signals: [
    {
      id: 'war-content-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch content-scripts/content.css — a content-script stylesheet exposed to every ' +
        'origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'content-scripts/content.css'),
    },
    {
      id: 'war-selection-toolbar-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch content-scripts/selection-toolbar.css — the selection-toolbar stylesheet, ' +
        'a second independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content-scripts/selection-toolbar.css'),
    },
    {
      id: 'war-floating-find-similar-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch content-scripts/floating-find-similar.css — a third vendor-named ' +
        'stylesheet, corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content-scripts/floating-find-similar.css'),
    },
  ],
};
